
import { ActionMenuItem, BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

const actionEnums = [
    BaseActionEnum.Export,
    BaseActionEnum.Run,
];

const actionItems = getActionMenuItems(actionEnums);

export const alarmNotificationAdminReportActionItems = actionItems.map((item) => {
  if (item.action === BaseActionEnum.Export) {
    return {
      ...item,
      subActions: item.subActions?.filter(o => o.action === BaseActionEnum.Excel)
    };
  }
  return item;
}) as ActionMenuItem[];
